import { IRequest } from '@r1-frontend/shared/types/IRequest';

export interface IEverywhereWatchItem {
    serviceId: number,
    serviceName: string,
    price: number,
    status: 0 | 1,
    dateFrom: number,
    dateFromFormatted?: string,
    dateTo: number,
    dateToFormatted?: string,
    currentPrice: number,
    tvSlotsCount: number,
}

/**
 * Проверяет статус услуг "Смотри везде"
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/DomruTv/0c0d38a55a5a18a36bda0dde75e29ab4
 */
export const getEverywhereWatchList = (): IRequest => ({
    uri: '/v1/domru-tv/everywhere-watch-list',
    method: 'GET',
    withAuth: true,
    withProvider: true,
});
